import { IReferenceCandidateForm } from '../../../../common/models/reference/IReferenceCandidateForm';
import { IContactMainInfo } from '../../../../common/models/contact/IContactMainInfo';
import { any, toLower } from 'ramda';
import { IFormattedMessage } from '../../../../common/models/common/IFormattedMessage';

export const errorMessages: { [title: string]: IFormattedMessage } = {
  firstName: { id: 'candidateForm.firstNameError', defaultMessage: 'Please provide a valid first name' },
  lastName: { id: 'candidateForm.lastNameError', defaultMessage: 'Please provide a valid last name' },
  email: { id: 'emailError', defaultMessage: 'Please provide a valid email address' },
  phone: { id: 'phoneNumberError', defaultMessage: 'Please provide a valid phone number' },
  existed1: { id: 'candidateForm.alreadyAddedReference', defaultMessage: 'Already added this reference' },
  existed2: { id: 'candidateForm.addedThemselves', defaultMessage: 'Please provide valid reference information' },
  unreachablePhone: {
    id: 'unreachablePhone',
    // eslint-disable-next-line max-len
    defaultMessage: 'This number cannot receive text messages. Please provide a mobile number or use email address instead.'
  }
};

const sameContact = (
  { id, email, phoneNumber, firstName, lastName }: IContactMainInfo,
  existed: IContactMainInfo | IReferenceCandidateForm
) => ((
  toLower(existed.firstName) === toLower(firstName)
  && toLower(existed.lastName) === toLower(lastName)
  && existed.phoneNumber === phoneNumber
  && Boolean(phoneNumber))
  || existed.email === email) && existed.id !== id;

export const referenceExists = (
  reference: IContactMainInfo,
  references: IReferenceCandidateForm[]
) => (
  any(ref => sameContact(reference, ref), references));

export const addThemselves = (
  candidate: IContactMainInfo,
  existed: IContactMainInfo | IReferenceCandidateForm
) => sameContact(candidate, existed);
